import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    Lane,
} from 'app/Apps/OrderManagement/Lanes/lanes.types'

import requestConfig from 'app/requests/Lane/Lane.requests'

const useGetLane = (id) => {
    return useRequest<Lane>({
        key: RequestKeys.getLaneById,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requestConfig.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetLane
